import React from "react";
import LoginHeader from "../../blocks/LoginHeader";
import Form from "../form/Form";
import Container from "../../blocks/Container";

const title = "Two-factor authentication";
const message = "Enter a security code generated by your two-factor authentication app to verify it’s you.";

const TOTPForm = ({ onValidate }) => {
  const onSubmit = (formData) => {
    onValidate(formData.code);
  };

  const fields = [
    {
      type: "text",
      name: "code",
      label: "Code",
      validation: (value) => (!value ? "Code is required" : null),
    },
  ];

  return (
    <Container>
      <LoginHeader title={title} message={message} />
      <Form buttonText="Verify" buttonBottom={false} fields={fields} onSubmit={onSubmit} />
    </Container>
  );
};

export default TOTPForm;
